import { backdropAtom, destInfoModalAtom } from '@/commons/constants';
import { masterDestListAtom } from '@/interfaces/plan/manage';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { DataGrid, GridColDef, GridRenderCellParams, useGridApiRef, gridPaginatedVisibleSortedGridRowIdsSelector } from '@mui/x-data-grid';
import * as _ from 'lodash';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ClearIcon from '@mui/icons-material/Clear';
import { CustomTextField } from '@/components/exec/common/CustomMui';
import * as XLSX from 'xlsx';

import {
  Alert,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  Switch,
  Typography,
} from '@mui/material';
import DestInfo from './DestInfo';
import { regionAtom } from '@/interfaces/region';
import { RegionGroup } from '@/types/regions';
import { deleteDuplicateCoords, getDuplicateCoords, putCoordsRegion } from '@/interfaces/plan/manage';

const MainWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow:hidden;
  gap: 0.5rem;
  .filterRow {
    width: 100%;
    height: 4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  }
  .listBody{
    width: 100%;
    height: 100%;
    flex-grow:1;
    overflow:hidden;
  }
`;

export default function Dest() {
  const setBackdrop = useSetAtom(backdropAtom);
  const setDestInfoModal = useSetAtom(destInfoModalAtom);

  const { data: regionList } = useAtomValue(regionAtom);
  const { data: destList } = useAtomValue(masterDestListAtom);
  const [checkedList, setCheckedList] = useState<any[]>([]);

  const [filterName, setFilterName] = useState<String>();
  const [filterAddress, setFilterAddress] = useState<String>();
  const [filterRegion, setFilterRegion] = useState<any>();

  const [contents, setContents] = useState<any[]>();
  const [modifyList, setModifyList] = useState<any[]>([]);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({
    open: false,
    message: '',
    severity: 'success',
  });
  const [dupDialog, setDupDialog] = useState<{ open: boolean; data: any[] }>({ open: false, data: [] });
  const [showAllAddress, setShowAllAddress] = useState(false);

  const column: GridColDef[] = [
    { field: 'display_customer_id', headerName: '거래처 코드', flex: 1, headerAlign: 'center' },
    { field: 'name', headerName: '배송지', flex: 1, headerAlign: 'center' },
    { field: 'customer_code', headerName: '거래처 사업자번호', flex: 1, headerAlign: 'center' },
    showAllAddress
      ? {
          field: 'allAddress',
          headerName: '배송지 주소',
          flex: 2,
          headerAlign: 'center',
          renderCell: (param) => {
            return (
              <div>
                <span>{param.value.inputAddress}</span>
                <br />
                <span>(도로명) : {param.value.roadAddress}</span>
                <br />
                <span>(지번) : {param.value.jibunAddress}</span>
              </div>
            );
          },
        }
      : {
          field: 'address',
          headerName: '배송지 주소',
          flex: 2,
          headerAlign: 'center',
        },
    { field: 'region', headerName: '권역', flex: 1, headerAlign: 'center', align: 'center' },
    {
      field: 'vWork_time',
      headerName: '배송가능시간',
      width: 120,
      headerAlign: 'center',
      align: 'center',
      renderCell: (param) => {
        const length = param.value.length;
        return (
          <div>
            {param.value[0].start + ' ~ ' + param.value[0].end}
            {length > 1 ? '외 ' + (length - 1) : ''}
          </div>
        );
      },
    },
    { field: 'vDwell_time', headerName: '체류시간', width: 80, headerAlign: 'center', align: 'center' },
    { field: 'memo', headerName: '메모', width: 150, headerAlign: 'center', align: 'center' },
    { field: 'create_dt', headerName: '등록일', width: 140, headerAlign: 'center', align: 'center' },
    { field: 'update_dt', headerName: '수정일', width: 140, headerAlign: 'center', align: 'center' },
    {
      field: 'coordsCheck',
      headerName: '위치확인',
      width: 80,
      headerAlign: 'center',
      align: 'center',
      renderCell: (param?: GridRenderCellParams<any, string[]>) => {
        return (
          <div
            style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            {param.value ? <DoneAllIcon htmlColor="#7a7" /> : <ClearIcon htmlColor="#d77" />}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    if (destList) {
      setBackdrop(false);
      let filterList = destList;
      if (filterName && filterName !== null) {
        filterList = _.filter(filterList, function (o) {
          return (o.name ?? '').indexOf(filterName) > -1;
        });
      }
      if (filterAddress && filterAddress !== null) {
        filterList = _.filter(filterList, function (o) {
          return (o.address ?? '').indexOf(filterAddress) > -1;
        });
      }
      if (filterRegion && filterRegion !== null) {
        filterList = _.filter(filterList, ['region', filterRegion]);
      }
      console.log(filterList)
      const temp = _.map(filterList, (item) => {
        return {
          ...item,
          id: item.seq,
          vWork_time: item.work_time,
          vDwell_time: item.dwell_time / 60 + '분',
          address: item.address,
          allAddress: {
            inputAddress: item.address,
            roadAddress: item.roadAddress ?? '-',
            jibunAddress: item.jibunAddress ?? '-',
          },
          coordsCheck: item.lat !== null && item.lng !== null,
        };
      });
      setContents(_.sortBy(temp, ['coordsCheck']));
    }
  }, [destList, filterName, filterAddress, filterRegion]);

  const apiRef = useGridApiRef();

  const handleSelectionModelChange = (val: any) => {
    const temp = val.map((item: number) => {
      return _.find(contents, ['id', item]);
    });
    setCheckedList(temp);
  };

  const handleSelectPageClick = () => {
    const pageIds = gridPaginatedVisibleSortedGridRowIdsSelector(apiRef);
    const current = new Set(apiRef.current.getSelectedRows().keys());
    const allSelected = pageIds.every((id) => current.has(id));
    if (allSelected) {
      pageIds.forEach((id) => current.delete(id));
    } else {
      pageIds.forEach((id) => current.add(id));
    }
    apiRef.current.setRowSelectionModel([...current]);
  };

  const handleSelectAllClick = () => {
    const allIds = (contents ?? []).map((row) => row.id);
    const current = apiRef.current.getSelectedRows();
    if (current.size === allIds.length) {
      apiRef.current.setRowSelectionModel([]);
    } else {
      apiRef.current.setRowSelectionModel(allIds);
    }
  };

  const handleRowClick = (item: any) => {
    setModifyList([item]);
    setDestInfoModal(true);
  };

  const handleSelectModifyClick = (e: any) => {
    setModifyList(checkedList);
    setDestInfoModal(true);
  };

  const handleCheckDuplicatesClick = async () => {
    setBackdrop(true);
    try {
      const res = await getDuplicateCoords();
      const { groups } = res.data.data;
      setDupDialog({ open: true, data: groups });
    } catch (e) {
      setSnackbar({ open: true, message: '중복 조회 중 오류가 발생했습니다.', severity: 'error' });
    } finally {
      setBackdrop(false);
    }
  };

  const handleMergeDuplicatesClick = async () => {
    setBackdrop(true);
    try {
      const res = await deleteDuplicateCoords();
      const { mergedGroups, deletedCoords } = res.data.data;
      setDupDialog({ open: false, data: [] });
      setSnackbar({
        open: true,
        message: `중복 정리 완료 (처리 그룹: ${mergedGroups}, 삭제 건수: ${deletedCoords})`,
        severity: 'success',
      });
    } catch (e) {
      setSnackbar({ open: true, message: '중복 정리 중 오류가 발생했습니다.', severity: 'error' });
    } finally {
      setBackdrop(false);
    }
  };

  const handleUpdateRegionClick = async () => {
    setBackdrop(true);
    try {
      const res = await putCoordsRegion();
      const { total, updated, notFound } = res.data.data;
      setSnackbar({
        open: true,
        message: `권역 할당 완료 (전체: ${total}, 성공: ${updated}, 미매핑: ${notFound})`,
        severity: 'success',
      });
    } catch (e) {
      setSnackbar({ open: true, message: '권역 할당 중 오류가 발생했습니다.', severity: 'error' });
    } finally {
      setBackdrop(false);
    }
  };

  const excelDown = () => {
    if (contents && contents.length > 0) {
      const excelContent = contents.map((dItem: any, dIndex: number) => {
        const retVal = {
          고객사코드: dItem.customer_code,
          배송지: dItem.name,
          배송지주소: dItem.address,
          도로명주소: dItem.allAddress.roadAddress,
          지번주소: dItem.allAddress.jibunAddress,
          권역: dItem.region,
          배송가능시간: dItem.vWork_time.map((t: { start: string; end: string }) => t.start + ' ~ ' + t.end).join(', '),
          체류시간: dItem.vDwell_time,
          메모: dItem.memo,
          위치확인: dItem.coordsCheck ? 'O' : 'X',
        };
        return retVal;
      });
      const workSheet = XLSX.utils.json_to_sheet(excelContent);
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, '배차차량목록');
      XLSX.writeFile(workBook, '배차차량목록.xlsx');
    }
  };

  return (
    <>
      <MainWrap>
        <div className="filterRow">
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            <CustomTextField
              size="small"
              label="배송지"
              variant="outlined"
              sx={{ width: '15%' }}
              slotProps={{ inputLabel: { shrink: true } }}
              onChange={(e) => setFilterName(e.target.value)}
            />
            <CustomTextField
              size="small"
              label="주소"
              variant="outlined"
              sx={{ width: '25%' }}
              slotProps={{ inputLabel: { shrink: true } }}
              onChange={(e) => setFilterAddress(e.target.value)}
            />
            {regionList && (
              <FormControl size="small" sx={{ width: '10rem' }}>
                <InputLabel id="demo-simple-select-label">권역</InputLabel>
                <Select
                  size="small"
                  label="권역"
                  // value={single.region ?? '-'}
                  onChange={(e) => setFilterRegion(e.target.value)}
                  // disabled={!data?.shipping?.option}
                >
                  <MenuItem value={null}>선택안함</MenuItem>
                  <MenuItem value={'-'}>-</MenuItem>
                  {regionList.map((item: RegionGroup, index: number) => (
                    <MenuItem key={index} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </div>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <FormControlLabel
              control={<Switch checked={showAllAddress} onChange={(e) => setShowAllAddress(e.target.checked)} />}
              label="확인된 주소 표시"
              sx={{ whiteSpace: 'nowrap', mr: 0 }}
            />
            <Button
              variant="contained"
              color="secondary"
              size="large"
              sx={{ whiteSpace: 'nowrap' }}
              onClick={handleUpdateRegionClick}
            >
              권역 업데이트
            </Button>
            <Button size="large" variant="outlined" sx={{ whiteSpace: 'nowrap' }} onClick={handleSelectPageClick}>
              현재 페이지 선택
            </Button>
            <Button size="large" variant="outlined" sx={{ whiteSpace: 'nowrap' }} onClick={handleSelectAllClick}>
              전체 선택
            </Button>
            <Button
              variant="contained"
              color="info"
              size="large"
              sx={{ width: '6rem' }}
              onClick={handleSelectModifyClick}
            >
              선택수정
            </Button>
            <Button
              variant="contained"
              color="success"
              size="large"
              sx={{ width: '8rem' }}
              onClick={excelDown}
              startIcon={<ExcelIcon />}
            >
              전체 다운로드
            </Button>
          </div>
        </div>
        <div className="listBody">
          <DataGrid
            apiRef={apiRef}
            checkboxSelection
            keepNonExistentRowsSelected
            disableColumnMenu
            disableColumnResize
            disableRowSelectionOnClick
            columns={column}
            rows={contents && contents.length > 0 ? contents : []}
            key={showAllAddress ? 'all' : 'simple'}
            getRowHeight={showAllAddress ? () => 'auto' : undefined}
            sx={{
              ...(showAllAddress
                ? { '& .MuiDataGrid-cell': { alignItems: 'flex-start', paddingTop: '8px', paddingBottom: '8px' } }
                : {}),
              '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': { display: 'none' },
            }}
            onRowClick={(e) => handleRowClick(e.row)}
            onRowSelectionModelChange={(val) => handleSelectionModelChange(val)}
          />
        </div>
      </MainWrap>
      <DestInfo target={modifyList} />
      <Dialog open={dupDialog.open} onClose={() => setDupDialog({ open: false, data: [] })} maxWidth="md" fullWidth>
        <DialogTitle>
          중복 배송지 확인
          <Chip label={`${dupDialog.data.length}건`} color="warning" size="small" sx={{ ml: 1 }} />
        </DialogTitle>
        <DialogContent dividers>
          {dupDialog.data.length === 0 ? (
            <Typography color="text.secondary">중복된 배송지가 없습니다.</Typography>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {dupDialog.data.map((group: any, i: number) => (
                <div key={i} style={{ border: '1px solid #ddd', borderRadius: 6, padding: '0.75rem' }}>
                  <Typography variant="subtitle2" gutterBottom>
                    {group.name} · {group.address}
                    {group.customer_code && (
                      <span style={{ color: '#888', marginLeft: 8 }}>({group.customer_code})</span>
                    )}
                  </Typography>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                    {group.coords.map((coord: any) => (
                      <Chip
                        key={coord.seq}
                        label={`seq:${coord.seq} · 주문:${coord.usedCount}건 · 배송이력:${coord.rDestsCount}건 · ${coord.lat ? '좌표O' : '좌표X'}`}
                        color={coord.isKeep ? 'success' : 'default'}
                        variant={coord.isKeep ? 'filled' : 'outlined'}
                        size="small"
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDupDialog({ open: false, data: [] })}>닫기</Button>
          {dupDialog.data.length > 0 && (
            <Button variant="contained" color="error" onClick={handleMergeDuplicatesClick}>
              정리 실행
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

const ExcelIcon = () => {
  return (
    <svg width="1.2rem" height="1.2rem" viewBox="0 0 557 640" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M553.342 636.339H79.2432V3.66138H416.3V145.611H553.342V636.339Z"
        fill="#FCFCFC"
        stroke="#818181"
        stroke-width="10"
        stroke-miterlimit="10"
      />
      <path
        d="M294.483 162.534H27.4363C12.2836 162.534 0 174.828 0 189.994V457.271C0 472.436 12.2836 484.73 27.4363 484.73H294.483C309.635 484.73 321.919 472.436 321.919 457.271V189.994C321.919 174.828 309.635 162.534 294.483 162.534Z"
        fill="#107C42"
      />
      <path d="M256 444H209.788L73 214H120.136L256 444Z" fill="white" />
      <path d="M73 444H119.212L256 214H208.864L73 444Z" fill="white" />
      <path d="M416.3 244.914H338.746V279.33H416.3V244.914Z" fill="#21A365" />
      <path d="M512.144 244.914H434.59V279.33H512.144V244.914Z" fill="#33C481" />
      <path d="M416.3 296.904H338.746V331.321H416.3V296.904Z" fill="#107C42" />
      <path d="M512.144 296.904H434.59V331.321H512.144V296.904Z" fill="#21A365" />
      <path d="M416.3 348.895H338.746V383.312H416.3V348.895Z" fill="#195D38" />
      <path d="M512.144 348.895H434.59V383.312H512.144V348.895Z" fill="#104B2B" />
    </svg>
  );
};
